import BaseClient from '@/app/model/api/response/baseApiClient'

class VarietyGrowthEditApi extends BaseClient {
  public doVarietyGrowthEdit (id: string, bodyData: {[key:string]: any}) {
    const path:string = '/v1/master/variety-growths/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new VarietyGrowthEditApi()
